import React, { useRef, useState, useEffect } from 'react'
import {
  Timer,
  Star,
  PreviousOutline,
  NextOutline,
  Reset,
  Close,
  ArrowLeft,
  VolumeUpFilled,
  VolumeMuteFilled
} from '@carbon/icons-react'
import {
  Header,
  Theme,
  HeaderMenuButton,
  HeaderGlobalBar,
  HeaderGlobalAction,
  Button,
  Toggle
} from 'carbon-components-react'

function ActivityHeader(props) {
  const {
    isCanvas,
    isPractice,
    isContained,
    isActive,
    Completed,
    Status,
    resetValue,
    imageFile,
    displayBurgerIcon,
    isSmartSlide,
    displayWalkThrough,
    currentWalkThroughStep,
    hideHeader,
    exerciseList,
    previousExerciseList,
    disableClick,
    isGuidedActivity,
    muteStatus,
    handleBotVolume,
    isSequence,
    isSmartPaper,
    isClassroom
  } = props //data to check
  const { timerValue, activityName, scoreValue, totalScoreValue } = props //data to display
  const {
    onMenuClick,
    onLeftClick,
    onRightClick,
    onResetClick,
    onDoneClick,
    onCloseClick,
    onSequenceChange
  } = props //click function to parent

  const [activityCount, setActivityCount] = useState('')
  const [isMuteClick, setIsMuteClick] = useState(false)

  useEffect(() => {
    let totActivityCount = exerciseList.length + previousExerciseList.length
    let currentActivityCount = previousExerciseList.length
    setActivityCount(currentActivityCount + ' / ' + totActivityCount)
  }, [exerciseList, previousExerciseList])

  useEffect(() => {
    if (isMuteClick) {
      handleBotVolume(isMuteClick)
      setIsMuteClick(false)
    } else {
      handleBotVolume(isMuteClick)
    }
  }, [isMuteClick])

  return (
    <Theme theme='g100'>
      <Header className='act-header-container' aria-label='IBM Platform Name'>
        <HeaderGlobalBar className='action-cont-1'>
          {isContained ? (
            <div
              className='back_test_cont'
              onClick={() => {
                if (!displayWalkThrough) {
                  onCloseClick()
                }
              }}
            >
              <ArrowLeft className='back-test-icon' />
              Back to Test
            </div>
          ) : !isContained ? (
            <HeaderMenuButton
              className='header-hambg'
              color='#ffffff'
              aria-label='Open menu'
              isCollapsible
              disabled={isContained || disableClick ? true : false}
              onClick={() => {
                onMenuClick()
              }}
            />
          ) : null}
          <Timer className='header-timer-style' />
          <span className='head-label'>{timerValue}</span>
          {(isPractice || Completed === 1 || !isActive) && (
            <Star className='header-score-style' />
          )}
          <span
            className='head-label'
            style={{
              display: isPractice
                ? 'flex'
                : Completed === 1 || !isActive
                ? 'flex'
                : 'none'
            }}
          >
            {scoreValue + '/' + totalScoreValue}
          </span>
        </HeaderGlobalBar>
        <HeaderGlobalBar className='action-cont-2'>
          {!isContained && (
            <HeaderGlobalAction
              className='header-prev-style'
              aria-label='Previous'
              disabled={disableClick}
              onClick={() => {
                if (!displayWalkThrough) {
                  onLeftClick()
                }
              }}
            >
              <PreviousOutline className='header-icon' />
            </HeaderGlobalAction>
          )}
          <span className='head-label'>{activityName}</span>
          <div className='head-act-type-cont'>
            <span className='head-sub-label'>{activityCount}</span>
            <span className='head-sub-label-type'>
              {isPractice ? 'Practice' : 'Test'}
            </span>
          </div>

          {!isContained && (
            <HeaderGlobalAction
              className='header-next-style'
              aria-label='Next'
              disabled={disableClick}
              onClick={() => {
                if (!displayWalkThrough) {
                  onRightClick()
                }
              }}
            >
              <NextOutline className='header-icon' />
            </HeaderGlobalAction>
          )}
        </HeaderGlobalBar>
        {isCanvas ? (
          <HeaderGlobalBar>
            {isSmartPaper && (
              <div className='sequence-togle-cont'>
                <p className='seq-tog-label'>Sequence</p>
                <Toggle
                  size='md'
                  // labelA='Sequence'
                  // labelB='On'
                  defaultToggled={isSequence}
                  hideLabel={true}
                  className='sequence-togle'
                  onToggle={(toggleStatus) => {
                    onSequenceChange(toggleStatus)
                  }}
                  id='toggle-1'
                  disabled={disableClick ? true : false}
                  toggled={isSequence}
                />
              </div>
            )}
            <p style={{ color: '#bdbdbd', fontSize: '10px', margin: '0px' }}>
              1.0.4{' '}
            </p>
          </HeaderGlobalBar>
        ) : (
          <HeaderGlobalBar>
            {muteStatus ? (
              <Button
                className='header-icon-sec'
                hasIconOnly
                iconDescription={'Unmute'}
                renderIcon={VolumeMuteFilled}
                tooltipAlignment='center'
                tooltipPosition='bottom'
                disabled={disableClick ? true : false}
                onClick={() => {
                  setIsMuteClick(true)
                }}
              />
            ) : (
              <Button
                className='header-icon-sec'
                hasIconOnly
                iconDescription={'Mute'}
                renderIcon={VolumeUpFilled}
                tooltipAlignment='center'
                tooltipPosition='bottom'
                disabled={disableClick ? true : false}
                onClick={() => {
                  setIsMuteClick(true)
                }}
              />
            )}
            <Button
              className='header-button'
              kind='primary'
              size='lg'
              type='button'
              disabled={true}
            >
              Feedback
            </Button>
            {!isClassroom && (
              <Button
                className='header-button'
                kind='primary'
                size='lg'
                type='button'
                disabled={
                  isCanvas
                    ? true
                    : Completed === 1 || !isActive || disableClick
                    ? true
                    : false
                }
                onClick={() => {
                  if (!displayWalkThrough) {
                    onDoneClick()
                  }
                }}
              >
                {isContained ? 'Save' : 'Submit'}
              </Button>
            )}
            {!isClassroom && (
              <Button
                className='header-icon-sec'
                hasIconOnly={true}
                iconDescription='Reset'
                renderIcon={Reset}
                tooltipAlignment='center'
                tooltipPosition='bottom'
                disabled={
                  isCanvas
                    ? true
                    : disableClick
                    ? true
                    : displayWalkThrough && currentWalkThroughStep === 3
                    ? false
                    : isContained
                    ? true
                    : isPractice && Completed === 0 && isActive
                    ? false
                    : Status &&
                      Status.toLowerCase() === 'rework' &&
                      resetValue === 0
                    ? false
                    : true
                }
                onClick={() => {
                  if (!displayWalkThrough) {
                    if (isPractice && isActive && Completed === 0) {
                      onResetClick('resetPractice')
                    } else {
                      onResetClick('resetTest')
                    }
                  }
                }}
              />
            )}
            {!isContained && (
              <Button
                className='header-icon-sec'
                hasIconOnly
                iconDescription='Close'
                renderIcon={Close}
                tooltipAlignment='center'
                tooltipPosition='bottom'
                disabled={
                  isClassroom
                    ? false
                    : isCanvas
                    ? true
                    : isContained
                    ? true
                    : disableClick
                }
                onClick={() => {
                  if (!displayWalkThrough) {
                    onCloseClick()
                  }
                }}
              />
            )}
          </HeaderGlobalBar>
        )}
      </Header>
    </Theme>
  )
}
export { ActivityHeader }
